import { http } from '@haohan/clw-utils'

const POWER = '/api/v1/permissions'
const ROLE = '/api/v1/roles'
const USER = '/api/v1/users'
const LOG = '/api/v1/journals/query'
const SETTING = '/api/v1/projects'
const BELONG = '/api/v1/city'
const COMPANY = '/api/v1/company'
const DEPLOYMENT = '/api/v1/deployment'
const ALARMSTAT = '/api/v1/alarmStat'
const ORGANIZATION = '/api/v1/organization'
const LDAP = '/api/v1/ldap'
const TEST = '/api/v1/log'
const TOKEN = '/api/v1/token'

/**
 * 获取权限列表
 */
export function getPowerList(params: any) {
  return http.request({
    method: 'get',
    url: `${POWER}`,
    params: params
  })
}

/**
 * 获取权限列表
 */
export function postPowerList(params: any) {
  return http.request({
    method: 'post',
    url: `${POWER}/query`,
    data: params
  })
}

/**
 * 获取权限树
 */
export function getPowerTree() {
  return http.request({
    method: 'get',
    url: `${POWER}/tree`
  })
}

/**
 * 获取角色列表
 */
export function getRoleList(params: any) {
  return http.request({
    method: 'get',
    url: `${ROLE}`,
    params: params
  })
}

/**
 * 获取角色列表
 */
export function postRoleList(params: any) {
  return http.request({
    method: 'post',
    url: `${ROLE}/query`,
    data: params
  })
}

/**
 * 新增角色
 */
export function addRole(params: any) {
  return http.request({
    method: 'post',
    url: `${ROLE}`,
    data: params
  })
}

/**
 * 编辑角色
 */
export function editRole(id: any, params: any) {
  return http.request({
    method: 'put',
    url: `${ROLE}/${id}`,
    data: params
  })
}

/**
 * 删除角色
 */
export function delRole(id: any) {
  return http.request({
    method: 'DELETE',
    url: `${ROLE}/${id}`
  })
}

/**
 * 获取用户列表 (已废弃)
 */
export function getUserList(params: any) {
  return http.request({
    method: 'get',
    url: `${USER}`,
    params: params
  })
}

/**
 * 获取用户列表
 */
export function postUserList(params: any) {
  return http.request({
    method: 'post',
    url: `${USER}/query`,
    data: params
  })
}

/**
 * 获取用户详情
 */
export function getUserDetail(id: string) {
  return http.request({
    method: 'get',
    url: `${USER}/${id}`
  })
}

/**
 * 新增用户
 */
export function addUser(params: any) {
  return http.request({
    method: 'post',
    url: `${USER}`,
    data: params
  })
}

/**
 * 编辑用户
 */
export function editUser(id: any, params: any) {
  return http.request({
    method: 'put',
    url: `${USER}/${id}`,
    data: params
  })
}

/**
 * 编辑用户密码
 */
export function editPassword(id: any, params: any) {
  return http.request({
    method: 'put',
    url: `${USER}/${id}/changePassword`,
    data: params
  })
}

/**
 * 重置用户密码
 */
export function resetPassword(id: any, params: any) {
  return http.request({
    method: 'put',
    url: `${USER}/${id}/resetPassword`,
    data: params
  })
}

/**
 * 删除用户
 */
export function delUser(id: any) {
  return http.request({
    method: 'DELETE',
    url: `${USER}/${id}`
  })
}

/**
 * 获取日志列表
 */
export function getLogList(params: any) {
  return http.request({
    method: 'post',
    url: `${LOG}`,
    data: params
  })
}

/**
 * 获取日志列表
 */
export function postLogList(params: any) {
  return http.request({
    method: 'post',
    url: `${LOG}`,
    data: params
  })
}

/**
 * 获取配置项
 */
export function getSettings(pid: any, name: string) {
  return http.request({
    method: 'get',
    url: `${SETTING}/${pid}/settings/${name}`
  })
}
/**
 * 添加
 */
export function postSettings(pid: any, data: any) {
  return http.request({
    method: 'POST',
    url: `${SETTING}/${pid}/settings`,
    data
  })
}
/**
 * 修改
 */
export function putSettings(pid: any, data: any) {
  return http.request({
    method: 'PUT',
    url: `${SETTING}/${pid}/settings/${data.id}`,
    data
  })
}
/**
 * 删除配置项
 */
export function delSettings(pid: any, name: string) {
  return http.request({
    method: 'DELETE',
    url: `${SETTING}/${pid}/settings/${name}`
  })
}
/**
 * 获取指定项目的配置项列表
 * ${type ? `?type=${type}` : ''}
 */
export function getSettingsList(pid: any, data: any, type = 'GLOBAL') {
  if (!pid) return
  return http.request({
    method: 'POST',
    url: `${SETTING}/${pid}/settings/query?type=${type}`,
    data
  })
}

/**
 * 获取API前缀配置列表
 */
export function getApiPrefixSettingsList(pid: any, data: any) {
  return http.request({
    method: 'POST',
    url: `${SETTING}/${pid}/settings/query?type=${data.type}`,
    data
  })
}
/**
 * 归属地 列表
 */
export function belongList(data: any) {
  return http.request({
    method: 'post',
    url: `${BELONG}/query`,
    data: data
  })
}
/**
 * 归属地 树
 */
export function belongTree() {
  return http.request({
    method: 'get',
    url: `${BELONG}/tree`
  })
}
/**
 * 归属地 新增
 */
export function belongAdd(params: any) {
  return http.request({
    method: 'post',
    url: `${BELONG}`,
    data: params
  })
}

/**
 * 归属地 编辑
 */
export function belongEdit(id: any, params: any) {
  return http.request({
    method: 'put',
    url: `${BELONG}/${id}`,
    data: params
  })
}
/**
 * 归属地 删除
 */
export function belongDel(id: any) {
  return http.request({
    method: 'delete',
    url: `${BELONG}/${id}`
  })
}
/**
 * 归属地 删除
 */
export function belongUp(data: any) {
  return http.request({
    method: 'POST',
    url: `${BELONG}/import`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

/**
 * 管理中心 - 获取公司详情
 */
export function getCompanyDetail(params?: any) {
  return http.request({
    method: 'get',
    url: `${COMPANY}/detail`,
    params: params
  })
}

/**
 * 管理中心 - 公司信息 - 编辑
 */
export function editCompany(id: any, params: any) {
  return http.request({
    method: 'put',
    url: `${COMPANY}/${id}`,
    data: params
  })
}

/**
 * 管理中心 - 公司信息 - 编辑
 */
export function editCompanySecurity(id: any, params: any) {
  return http.request({
    method: 'put',
    url: `${COMPANY}/${id}/security`,
    data: params
  })
}

/**
 * 管理中心 - 已发布项目查询
 */
export function queryDeployedProjectList(params?: any) {
  return http.request({
    method: 'post',
    url: `${DEPLOYMENT}/query`,
    data: params
  })
}

/**
 * 管理中心 - 已发布项目服务器性能查询
 */
export function queryDeployedProjectServerStat(deploymentId?: any) {
  return http.request({
    method: 'get',
    url: `${DEPLOYMENT}/${deploymentId}/stat`
  })
}

/**
 * 管理中心 - 告警监控异常日志查询(当前项目)
 */
export function queryAlarmStatByProjectId(projectId: string, params?: any) {
  return http.request({
    method: 'post',
    url: `${ALARMSTAT}/projects/${projectId}/query`,
    data: params
  })
}

/**
 * 管理中心 - 监控大屏请求
 */
export function getManagementDashboardData() {
  return http.request({
    method: 'get',
    url: `${ALARMSTAT}/alarmScreen/query`
  })
}

/**
 * 管理中心 - 组织架构 - 获取组织架构列表
 */
export function getOrganizationList(params: any) {
  return http.request({
    method: 'post',
    url: `${ORGANIZATION}/query`,
    data: params
  })
}

/**
 * 管理中心 - 组织架构 - 新增组织架构结点
 */
export function createOrganization(params: any) {
  return http.request({
    method: 'post',
    url: `${ORGANIZATION}`,
    data: params
  })
}

/**
 * 管理中心 - 组织架构 - 修改组织架构
 */
export function updateOrganization(organizationId: any, params: any) {
  return http.request({
    method: 'put',
    url: `${ORGANIZATION}/${organizationId}`,
    data: params
  })
}

/**
 * 管理中心 - 组织架构 - 删除组织架构
 */
export function deleteOrganization(organizationId: any) {
  return http.request({
    method: 'delete',
    url: `${ORGANIZATION}/${organizationId}`
  })
}

/**
 * 管理中心 - 组织架构 - 批量增加组织架构下用户列表
 */
export function updateOrganizationUser(organizationId: any, params: any) {
  return http.request({
    method: 'put',
    url: `${ORGANIZATION}/batchInsertUsers/${organizationId}`,
    data: params
  })
}

/**
 * 管理中心 - 用户管理 - 同步三方账号
 */
export function postLdapAccount(params: any) {
  return http.request({
    method: 'post',
    url: `${LDAP}/sync`,
    data: params
  })
}

/**
 * 获取日志
 */
export function testAutomationReq() {
  return http.request({
    method: 'get',
    url: `${TEST}/getLog`
  })
}

/**
 * 查询 Token
 */
export function queryTokenList(params: any) {
  return http.request({
    method: 'post',
    url: `${TOKEN}/query`,
    data: params
  })
}

/**
 * 新增 Token
 */
export function addToken(params: any) {
  return http.request({
    method: 'post',
    url: `${TOKEN}`,
    data: params
  })
}

/**
 * 编辑 Token
 */
export function editToken(id: any, params: any) {
  return http.request({
    method: 'put',
    url: `${TOKEN}/${id}`,
    data: params
  })
}

/**
 * 删除 Token
 */
export function deleteToken(id: any) {
  return http.request({
    method: 'DELETE',
    url: `${TOKEN}/${id}`
  })
}

/**
 * 生成 Token
 */
export function generateToken() {
  return http.request({
    method: 'get',
    url: `${TOKEN}/generate`
  })
}
